import React, {useState} from 'react';

const  Modal = props => {
    if (!props.show) {
        return null;
    }

    return (
        <div className="modal modal-is-open" onClick={props.onClose}>
            <div className="modal__box" onClick={e => e.stopPropagation()}>
                <div className="modal__box-head">
                    <h2>{props.title}</h2>
                    <div className="modal-close" onClick={props.onClose}><i className="fa-solid fa-xmark"></i></div>
                </div>
                <div className="modal__box-content">
                    <div dangerouslySetInnerHTML={{__html: props.content}} />
                </div>
            </div>
        </div>
    )
}

export default Modal;
